import { Alert, Button, Snackbar, Typography, Box } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { useEffect, useState } from 'react';

export type VirtualPrintDetail = { pdfUrl: string; listUrl: string };

export const VIRTUAL_PRINT_EVENT = 'ftl:virtual-print';

/**
 * Test-only virtual printer notification (ADO 27396). Renders nothing until a
 * VIRTUAL_PRINT_EVENT is dispatched (by postPrintItem), which can only happen
 * when the print lambda flags a sentinel virtual print AND the REACT_APP_VP_*
 * env vars are set - neither is ever true in Prod.
 */
export default function VirtualPrintToast() {
  const [detail, setDetail] = useState<VirtualPrintDetail | null>(null);

  useEffect(() => {
    const onVirtualPrint = (e: Event) => setDetail((e as CustomEvent<VirtualPrintDetail>).detail);
    window.addEventListener(VIRTUAL_PRINT_EVENT, onVirtualPrint);
    return () => window.removeEventListener(VIRTUAL_PRINT_EVENT, onVirtualPrint);
  }, []);

  return (
    <Snackbar
      open={!!detail}
      autoHideDuration={15000}
      onClose={() => setDetail(null)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 8 }}>
      <Alert
        onClose={() => setDetail(null)}
        severity="info"
        variant="filled"
        icon={<PrintIcon />}
        sx={{ borderRadius: 2, minWidth: '300px' }}>
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
            Virtual label captured
          </Typography>
          <Button color="inherit" size="small" onClick={() => window.open(detail?.pdfUrl, '_blank')}>
            View label
          </Button>
          <Button color="inherit" size="small" onClick={() => window.open(detail?.listUrl, '_blank')}>
            All captures
          </Button>
        </Box>
      </Alert>
    </Snackbar>
  );
}
